import compose from "ramda/src/compose";
import ifElse from "ramda/src/ifElse";
import length from "ramda/src/length";
import juxt from "ramda/src/juxt";
import filter from "ramda/src/filter";
import flatten from "ramda/src/flatten";
import map from "ramda/src/map";
import always from "ramda/src/always";
import identity from "ramda/src/identity";
import Stack from "@mui/material/Stack";
import {
  usePlacementWorksheetContext,
  usePlacementWorksheetSettingsContext,
} from "../../contexts/PlacementWorksheetContext";
import { PlacementWorksheetNotMatchedAccordion } from "./PlacementWorksheetNotMatchedAccordion";
import { PlacementWorksheetRightPopupSectionContainer } from "./PlacementWorksheetRightPopupSectionContainer";
import { pathOrArray } from "../../helpers/pathOrArray";
import { pathStatusEq } from "../../helpers/pathStatusEq";
import { flipedGt1 } from "../../helpers/flipedGt1";

const getUnitsOccupants = compose(ifElse(compose(flipedGt1, length), always([]), identity), pathOrArray(["occupants"]));

const getOccupants = compose<any, any, any, any>(flatten, map(getUnitsOccupants), pathOrArray(["unassignedUnits"]));

const getNewResidents = compose(filter(pathStatusEq("new")), getOccupants);

const getRenewingResidents = compose(filter(pathStatusEq("renewing")), getOccupants);

const getResidents = juxt([getNewResidents, getRenewingResidents]);

export const PlacementWorksheetNotMatchedSection: React.FC = () => {
  const { occupants } = usePlacementWorksheetContext();
  const { colors } = usePlacementWorksheetSettingsContext();

  const [newResidents, renewingResidents] = occupants ? getResidents(occupants) : [[], []];

  return (
    <>
      <PlacementWorksheetRightPopupSectionContainer title="Not Matched" subtitle="Select residents to match">
        <Stack spacing={2}>
          {!!newResidents.length && (
            <PlacementWorksheetNotMatchedAccordion
              title="New residents"
              markColor={colors.newResidentColor}
              // @ts-ignore
              residents={newResidents}
            />
          )}
          {!!renewingResidents.length && (
            <PlacementWorksheetNotMatchedAccordion
              title="Renewing residents"
              markColor={colors.renewingResidentColor}
              // @ts-ignore
              residents={renewingResidents}
            />
          )}
        </Stack>
      </PlacementWorksheetRightPopupSectionContainer>
    </>
  );
};
